import { useEffect, useState } from "react";

export default function CustomCursor() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const move = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  // Smoothly follow mouse
  useEffect(() => {
    const follow = () => {
      setCursorPos((prev) => ({
        x: prev.x + (mousePos.x - prev.x) * 0.15, // smoothness factor
        y: prev.y + (mousePos.y - prev.y) * 0.15,
      }));
      requestAnimationFrame(follow);
    };
    follow();
  }, [mousePos]);

  return (
    <>
      {/* Cursor group: circle + dot */}
      <div
        className="fixed top-0 left-0 pointer-events-none z-50"
        style={{ transform: `translate(${cursorPos.x}px, ${cursorPos.y}px)` }}
      >
        {/* Circle */}
        <div className="absolute w-16 h-16 rounded-full border border-white/70 -translate-x-1/2 -translate-y-1/2"></div>

        {/* Dot */}
        <div className="absolute w-2.5 h-2.5 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      </div>
    </>
  );
}
